import { commodityTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  selectGroupName: '',
  isLoading: false,
  error: {},
  packingList: null,
};

const Commodity = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case commodityTypes.GET_COMMODITY_DEFINITIONS:
      return {
        ...state,
        isLoading: true,
      };
    case commodityTypes.GET_COMMODITY_SUCCESS:
      return {
        ...state,
        data: action.payload?.comodityData,
        CountItems: action.payload?.CountItems,
        isLoading: false,
      };

    case commodityTypes.GET_COMMODITY_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case commodityTypes.GET_COMMODITY_BY_GUID_DEFINITIONS:
      return {
        ...state,
        isLoading: true,
      };
    case commodityTypes.GET_COMMODITY_BY_GUID_SUCCESS:
      return {
        ...state,
        milestoneConfig: action.payload.milestoneConfig,
        data: action.payload?.comodityData,
        isLoading: false,
      };

    case commodityTypes.GET_COMMODITY_BY_GUID_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case commodityTypes.GET_GROUPNAME:
      return {
        ...state,
        selectGroupName: action.payload,
      };

    case commodityTypes.GET_MILESTONESCONFIG_COMMODITY_SUCCESSS:
      return {
        ...state,
        milestoneConfig: action.payload
      }

    case commodityTypes.GET_MILESTONESCONFIG_COMMODITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    //------------------------PACKING LIST-------------------------
    case commodityTypes.GET_PACKINGLIST_COMMODITY:
      return {
        ...state,
        isLoading: true
      }
    case commodityTypes.GET_PACKINGLIST_COMMODITY_SUCCESSS:
      return {
        ...state,
        isLoading: false,
        packingList: action.payload
      }
    case commodityTypes.GET_PACKINGLIST_COMMODITY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      }

    default:
      return state;
  }
};

export default Commodity;
